export { default as pt_PT } from './pt-PT/translations.json';
export { default as en_GB } from './en-GB/translations.json';
export { default as es_ES } from './es-ES/translations.json';
export { default as fr_FR } from './fr-FR/translations.json';
